import css from './index.module.scss';
import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';
import EfImg from '@elem/ui/ef-img';
import EfLink from '@elem/ui/ef-link';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import React, { useEffect, useState } from 'react';

interface BlogType {
    img: string;
    title: string;
    date: string;
    link: string;
}
export default function Q() {
    const { t } = useLang('bkw');
    const [gap, setGap] = useState<number>(16);
    const blogs: BlogType[] = [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1738984994666/17_1.jpg',
            title: t('Q_blog1_title'),
            date: t('Q_blog1_date'),
            link: 'https://blog.ecoflow.com/de/balkonkraftwerk-anmelden-2025/',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1738985251534/17_2.jpg',
            title: t('Q_blog2_title'),
            date: t('Q_blog2_date'),
            link: 'https://blog.ecoflow.com/de/welche-leistung-darf-ein-balkonkraftwerk-ab-2025-haben/',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1738984995115/17_3.jpg',
            title: t('Q_blog3_title'),
            date: t('Q_blog3_date'),
            link: 'https://blog.ecoflow.com/de/bestes-balkonkraftwerk/',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1738984994907/17_4.jpg',
            title: t('Q_blog4_title'),
            date: t('Q_blog4_date'),
            link: 'https://blog.ecoflow.com/de/balkonkraftwerk-westausrichtung/',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1738984994484/17_5.jpg',
            title: t('Q_blog5_title'),
            date: t('Q_blog5_date'),
            link: 'https://blog.ecoflow.com/de/balkonkraftwerk-einspeiseverguetung-2025/',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1738984995368/17_6.jpg',
            title: t('Q_blog6_title'),
            date: t('Q_blog6_date'),
            link: 'https://blog.ecoflow.com/de/balkonkraftwerk-nur-eine-phase/',
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            if (window.innerWidth < 1024) {
                setGap(16);
            } else {
                setGap(24);
            }
        }
    }, []);

    return (
        <div id="bkw-Q" className={`bkw-Q bkw-box inner ${css['bkw-Q']}`}>
            <EfSpec />
            <div className="info">
                <h2 className="title">{t('Q_title')}</h2>
            </div>
            <Swiper
                className="blogs"
                modules={[Navigation]}
                spaceBetween={gap}
                // centeredSlides={gap !== 16}
                slidesPerView={'auto'}
                initialSlide={0}
                navigation
                // pagination={{ clickable: true }}
            >
                {blogs?.map((blog: BlogType, k: number) => (
                    <SwiperSlide className={`blog item-${k + 1}`} key={k}>
                        <EfLink
                            className="blog-box"
                            href={blog.link}
                            dataLayer={{
                                event: 'uaEvent',
                                event_name: 'select_news',
                                title_name: blog.title,
                                button_name: 'Image',
                            }}
                        >
                            <div className="blog-img">
                                <EfImg pc={blog.img} />
                            </div>
                            <div className="blog-info">
                                <p className="blog-label">{t('Q_label')}</p>
                                <p className="blog-title">{blog.title}</p>
                                <div className="blog-memo">
                                    <EfImg className="blog-logo" pc="https://websiteoss.ecoflow.com/upload/image/1738985975775/Ecoflow_Logo.png" />
                                    <div className="blog-text">
                                        <span className="blog-ecoflow">EcoFlow</span>
                                        <span className="blog-date"> - {blog.date}</span>
                                    </div>
                                </div>
                            </div>
                        </EfLink>
                    </SwiperSlide>
                ))}
            </Swiper>
            <EfSpec />
        </div>
    );
}
